import { registerCardComponent } from "@/components/generative-ui/envelope";
import { PersonaBuilderView } from "./PersonaBuilderView";
import { RoutingRuleView } from "./RoutingRuleView";
import { SDRTemplatePreviewView } from "./SDRTemplatePreviewView";

registerCardComponent("persona_builder", PersonaBuilderView);
registerCardComponent("routing_rule", RoutingRuleView);
registerCardComponent("sdr_template_preview", SDRTemplatePreviewView);

export { PersonaBuilderView, RoutingRuleView, SDRTemplatePreviewView };
